import React from 'react';

export default function Hero() {
  return (
    <section id="home" className="hero">
      <div className="hero-content">
        <p className="eyebrow">Arthanova Global</p>

        <h1>Building technology for a connected world.</h1>

        <p className="hero-text">
          Arthanova Global builds and delivers future-ready software, AI,
          automation and digital platforms for organisations preparing for
          growth, scale and transformation.
        </p>

        <div className="hero-actions">
          <a href="#contact" className="primary-btn">
            Start a conversation
          </a>

          <a href="#services" className="secondary-btn">
            View services
          </a>
        </div>
      </div>
    </section>
  );
}